export default function Modal() {
  const header = document.querySelector('.l-header');
  const main = document.querySelector('main');
  const breadcrumb = document.querySelector('.o-breadcrumb');
  const footer = document.querySelector('.l-footer');
  const hiddenElements = [header, main, breadcrumb, footer];
  // data-modal-srcがついた要素を取得
  const modalElement = document.querySelectorAll('[data-modal-src]');
  // 前回フォーカスしていた要素を保存する変数
  let lastFocusedElement = null;
  // フォーカス可能な要素のリスト
  let focusableElements = [];

  // モーダル対象があった時のみ、モーダルのDOMを生成
  if (modalElement) {
    // モーダルの各要素にクリック / キーボードイベントを設定
    modalElement.forEach((el) => {
      const videoURL = el.dataset.modalSrc;

      // アクセシビリティのための属性を追加
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
      if (!el.hasAttribute('role')) {
        el.setAttribute('role', 'button');
      }
      if (!el.hasAttribute('aria-haspopup')) {
        el.setAttribute('aria-haspopup', 'dialog');
      }

      // クリックイベント
      el.addEventListener('click', function () {
        // クリックした要素を保存
        lastFocusedElement = el;
        openModal(videoURL);
      });

      // キーボードイベント - Space or Enter キーでモーダルを開く
      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault(); // デフォルトのスクロール動作を防止
          // キーボード操作した要素を保存
          lastFocusedElement = el;
          openModal(videoURL);
        }
      });
    });

    // モーダル要素を作成
    let modal = document.createElement('div');
    modal.className = 'o-movie-modal';
    modal.classList.add('js-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', '動画プレイヤー');
    modal.setAttribute('tabindex', '-1');

    // モーダルの背景をクリックしたら閉じる
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    // キーボードイベントでフォーカストラップを実装
    modal.addEventListener('keydown', function (event) {
      // モーダルが開いている場合のみイベント処理
      if (!modal.classList.contains('is-open')) return;

      // ESCキーでモーダルを閉じる
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      // Tabキーでフォーカストラップ
      if (event.key === 'Tab') {
        // フォーカス可能な要素を更新
        updateFocusableElements(modal);

        if (focusableElements.length === 0) return;

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        // Shift+Tabで先頭要素からループ
        if (event.shiftKey && document.activeElement === firstFocusable) {
          lastFocusable.focus();
          event.preventDefault();
        }
        // Tabで末尾要素からループ
        else if (!event.shiftKey && document.activeElement === lastFocusable) {
          firstFocusable.focus();
          event.preventDefault();
        }
      }

      // スペースキーの処理
      if (event.key === ' ' || event.key === 'Spacebar') {
        // フォーカスが閉じるボタンにある場合は閉じる
        const activeElement = document.activeElement;
        const closeBtn = modal.querySelector('.o-movie-modal__button-close');

        if (activeElement === closeBtn) {
          closeModal();
          event.preventDefault();
        }
      }
    });

    // modalContentの要素を作成
    let modalContent = document.createElement('div');
    modalContent.className = 'o-movie-modal__video';

    // iframeのYouTube要素を作成
    let videoPlayer = document.createElement('iframe');
    videoPlayer.className = 'js-modal-video';
    videoPlayer.width = '560';
    videoPlayer.height = '315';
    videoPlayer.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    videoPlayer.allowFullscreen = true;
    videoPlayer.setAttribute('tabindex', '0'); // タブでフォーカス可能にする

    // 閉じるボタンを作成
    let closeBtn = document.createElement('button');
    closeBtn.className = 'o-movie-modal__button-close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = `
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <mask id='mask0_8286_2615' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_8286_2615)'>
        <path
          d='M6.40009 19.1911L4.80884 17.5998L10.4088 11.9998L4.80884 6.39984L6.40009 4.80859L12.0001 10.4086L17.6001 4.80859L19.1913 6.39984L13.5913 11.9998L19.1913 17.5998L17.6001 19.1911L12.0001 13.5911L6.40009 19.1911Z'
          fill='white'
        />
      </g>
    </svg>
    `;

    // 閉じるボタンにクリックイベントを設定
    closeBtn.addEventListener('click', closeModal);

    // modalの中身に各要素を追加
    modalContent.appendChild(videoPlayer);
    modalContent.appendChild(closeBtn);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
  }

  // フォーカス可能な要素を更新する関数
  function updateFocusableElements(container) {
    focusableElements = Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"], iframe',
      ),
    );
  }

  // モーダルを開く
  function openModal(videoURL) {
    // メインコンテンツを非表示に設定
    hiddenElements.forEach((element) => {
      if (element) element.setAttribute('aria-hidden', 'true');
    });

    let modal = document.querySelector('.js-modal');
    let videoPlayer = document.querySelector('.js-modal-video');
    let closeBtn = document.querySelector('.o-movie-modal__button-close');

    // YouTube動画のURLを設定
    videoPlayer.src = videoURL;
    modal.classList.add('is-open');

    // フォーカス可能な要素を更新
    updateFocusableElements(modal);

    // モーダルが開いたら閉じるボタンにフォーカス
    setTimeout(() => {
      closeBtn.focus();
    }, 100);
  }

  // モーダルを閉じる
  function closeModal() {
    // メインコンテンツの表示を元に戻す
    hiddenElements.forEach((element) => {
      if (element) element.removeAttribute('aria-hidden');
    });

    let modal = document.querySelector('.js-modal');
    let videoPlayer = document.querySelector('.js-modal-video');

    // 次に入ってくるsrcのために空にしておく
    videoPlayer.src = '';
    modal.classList.remove('is-open');

    // 元々フォーカスしていた要素にフォーカスを戻す
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }
}
